// extracted by mini-css-extract-plugin
export default {"SuggestCleanHistory":"cuyUO"};